module.exports = __webpack_public_path__ + "img/MF-B069A-BS.d68994a4.png";